import React from "react";
import "../styles/PassengerDetails.css";

const PassengerDetails = () => {
    return (
        <>
            <main className="passenger-details-main">
                <div className="passenger-details-content">
                    <section className="p-one">
                        <div className="p-details-heading">
                            <h1>Passenger one</h1>
                            <p>ADULT</p>
                        </div>
                        <div className="passenger-details">
                            <label htmlFor="">First name<input type="text" name="" id="" /></label>
                            <label htmlFor="">Last name<input type="text" name="" id="" /></label>
                            <label htmlFor="">Phone number<input type="tel" name="" id="" /></label>
                            <label htmlFor="">Email address<input type="email" name="" id="" /></label>
                        </div>
                    </section>
                    <section className="p-two">
                        <div className="p-details-heading">
                            <h1>Passenger two</h1>
                            <p>INFANT</p>
                        </div>
                        <div className="passenger-details">
                            <label htmlFor="">First name<input type="text" name="" id="" /></label>
                            <label htmlFor="">Last name<input type="text" name="" id="" /></label>
                            <label htmlFor="">Phone number<input type="tel" name="" id="" /></label>
                            <label htmlFor="">Email address<input type="email" name="" id="" /></label>
                        </div>
                    </section>
                    <section className="emergency-contact">
                        <div className="p-details-heading">
                            <h1>Emergency contact</h1>
                            <p>For all passengers</p>
                        </div>
                        <div className="passenger-details">
                            <label htmlFor="">Phone number<input type="tel" name="" id="" /></label>
                            <label htmlFor="">Email address<input type="email" name="" id="" /></label>
                        </div>
                    </section>
                </div>
                <section>
                    <div >
                        <div className="ticket">
                            <p>Tickets (1 passenger)</p>
                            <p>&#8358; 13000</p>
                        </div>
                        <div className="tax">
                            <p>Tax</p>
                            <p>&#8358; 230</p>
                        </div>
                        <div className="divider"></div>
                        <div className="total">
                            <p>Total</p>
                            <p>&#8358; 13230</p>
                        </div>
                    </div>
                    <button type="submit">
                        Continue to review and pay
                    </button>
                </section>
            </main>
        </>
    );
}
export default PassengerDetails;